import React, { useContext, useState } from 'react';
import { Accordion, AccordionContext, Card, Form, Row , Col} from 'react-bootstrap';
import httpService from '../../services/httpService';
import config from '../../config/config';
import icons from '../../assets/icons/icons';
import color from '../../assets/colors';

const HeroesFormAccordion = (props: any) => {
  var FormData = require('form-data');
  let formData = new FormData();

  const [validated, setValidated] = useState(false);
  const [state, setstate]: any = useState({});
  const [popUp, setpopUp] = useState({ images: [{}], status: false });
  const [file, setfile]: any = useState({});
  const [fileData, setFileData]:any= useState({});
  const [validationErrorList, setValidationErrorList]: any = useState({})
  const [isSuccess, setSuccess] = useState(false)
  
  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    setValidated(true);
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false || Object.keys(validationErrorList).length !== 0) {
      return;
    }
   
    formData.delete('data');
    formData.append('data', JSON.stringify(state));
    formData.append(`files.document`, fileData['files.document'], fileData['files.document'].name);
    httpService.invokeApi(
      {
        url: config.serviceUrlMain+props.data.Form.actionUrl,
        data: formData,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
      },
      (success: boolean, res: any) => {
        if (success && res.statusCode !== 400) {
          event.target.reset();
          setValidated(false);
          setstate({});
          setfile({});
          formData = new FormData();
          setSuccess(true)
        }
        else {
          if (res?.data?.errors instanceof Object) {
            let errors = Object.values(res?.data?.errors);
            if (errors?.length > 0) {
              console.log(errors);
            }
          }
        }
      }
    );
  };
  const clearFile = (name: string) => {
    setfile({ ...state, [name]: null });
    setstate({ ...state, [name]: null });
  };
  const renderingitem = (element: any, index?: any) => {
    if (element.type === 'submit') {
      return <input type={element.type} key={index} className="btn-contactbutton heroButton" name={element.name} />;
    } else if (element.type === 'select') {
      if (!state[`${element.name}`]) {
        setstate({ ...state, [element.name]: element.values[0]?.value });
      }
     
        return (
          element && (
            <div className="form-row mb-3 heroFormMaxWidth" key={index}>
              <div className="col">
                <select
                  className="form-control form-select"
                  name={element.name}
                  required={element.required}
                  defaultValue={element.values[1]}
                >
                  {element && element.values.map((selectitem: any, key: number) => {
                    return (
                      <React.Fragment key={key}>
                        <option value={selectitem.name}>{selectitem.name} </option>
                      </React.Fragment>
                    );
                  })}
                </select>
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      
    }  else if (element.type === 'file') {
      return (
        element && (
          <div className="form-row mb-3" key={index}>
            <div className="col">
              <label className="form-label form-label-bold">
                {element.label}
                {element.required && <span className={'error-message-astrid-show'}>*</span>}
                {element.infoIcon && (
                  <div
                    onClick={() => {
                      setpopUp({
                        status: true,
                        images: [
                          {
                            src: config.baseUrl + element.infoImage.url,
                            h: element.infoImage.height,
                            w: element.infoImage.width
                          }
                        ]
                      });
                    }}
                    className={'app-info-popup'}
                    style={{ backgroundImage: 'url(' + config.baseUrl + element.infoIcon.url + ')' }}
                  />
                )}
              </label>
              <div className="form-group files color">
                {file[`${element.name}`] && (
                  <span
                    className="app-clear"
                    onClick={() => {
                      clearFile(element.name);
                    }}
                  >
                    {icons.close('#000', '')}
                  </span>
                )}
                <Form.Control
                  id={element.type}
                  type={element.type}
                  name={element.name}
                  required={element.required}
                  value={state['element.name']}
                />
                <div className="app-file-upload-container">
                  {file[`${element.name}`] ? (
                    <div className="app-selcted-image">
                      <div className="app-image-preview">
                        <i className="fas fa-file fa-2x" />
                      </div>
                      <div className="app-details">
                        <span>{(Math.round((file[`${element.name}`].size / 1048576) * 100) / 100).toFixed(3)}MB</span>
                        <span>{file[`${element.name}`].name}</span>
                      </div>
                    </div>
                  ) : (
                    <React.Fragment>
                      {icons.dragDropIcon()}
                      <span className="m-t-10">Click or drag a file to this area to upload.</span>
                    </React.Fragment>
                  )}
                </div>
                {element && <Form.Control.Feedback type="invalid" id={element.name}>{element.errorMessage}</Form.Control.Feedback>}
              </div>
            </div>
          </div>
        )
      );
    } else {
      if (element.__component === undefined) {
        return (
          element && (
            <div className="form-row mb-3" key={index} style={{maxWidth:`${element.name ==='firstName'|| element.name ==='lastName'? 100: 60}% !important`}}>
            <div className="col">
                <label className="form-label form-label-bold">
                  {element.infoIcon && (
                    <div
                      onClick={() => {
                        setpopUp({
                          status: true,
                          images: [
                            {
                              src: config.baseUrl + element.infoImage.url,
                              h: element.infoImage.height,
                              w: element.infoImage.width
                            }
                          ]
                        });
                      }}
                      className={'app-info-popup'}
                      style={{ backgroundImage: 'url(' + config.baseUrl + element.infoIcon.url + ')' }}
                    />
                  )}
                </label>
                <Form.Control type={element.type}
                  onChange={(event: any) => {
                    changeHandlers(event, element);
                  }}
                  name={element.name} required={element.required} />
                {element.label}
                <div className="Contact-form-errorMessage">{validationErrorList[element.name]}</div>
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      } else {
        return (
          element && (
            <div className="form-row mb-3 heroFormMaxWidth" key={index} style={{maxWidth:`${element.name ==='firstName'|| element.name ==='lastName'? 100: 60}% !important`}}>
            <div className="col">
                <label className="form-label form-label-bold">
                  {element.label}
                  {element.required && <span className={'error-message-astrid-show'}>*</span>}
                  {element.infoIcon && (
                    <div
                      onClick={() => {
                        setpopUp({
                          status: true,
                          images: [
                            {
                              src: config.baseUrl + element.infoImage.url,
                              h: element.infoImage.height,
                              w: element.infoImage.width
                            }
                          ]
                        });
                      }}
                      className={'app-info-popup'}
                      style={{ backgroundImage: 'url(' + config.baseUrl + element.infoIcon.url + ')' }}
                    />
                  )}
                </label>
                <Form.Control type={element.type}
                  onChange={(event: any) => {
                    changeHandlers(event, element);
                  }}
                  name={element.name} required={element.required}  />
                <div className="Contact-form-errorMessage">{validationErrorList[element.name]}</div>
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      }

    }
  };


  const changeHandlers = (event: any, element: any) => {
    const Name = event.target.name;
    const Value = event.target.value;

    if (element.validationPattern) {
      let res = new RegExp(element.validationPattern, 'g');
      if (res.test(Value)) {
        let validationerrror = { ...validationErrorList }
        delete validationerrror[Name];
        setValidationErrorList(validationerrror)

      } else {

        setValidationErrorList({ ...validationErrorList, [Name]: element.validationMessage })
      }

    }
  }

  const FormGroups = (formData: any) => {
    return formData.map((items: any, i: number) => {
      return (
        <Row key={i}  className="groupElementMaxWidth">
          {items.map((item: any, i: number) => {
             let gridNumber = 6
             let xsNumber = 6
            return (
              <Col xs={xsNumber} md={gridNumber} key={i} >
                {renderingitem(item, i)}
              </Col>
            );
          })}
        </Row>
      );
    });
  };

  const mapFormGroup = (formData: any) => {
    let row: any = [];
    let rowElement: any[] = [];
    formData.map((e: any) => {
      rowElement.push(e);
      if (e.rowBreak) {
        row.push(rowElement);
        rowElement = [];
      }
      return null;
    });

    return FormGroups(row);
  };

  const renderForm = (element: any, index?: any) => {
    switch (element.__component) {
      case 'form.form-element':
        return <React.Fragment key={index}><div>{renderingitem(element)}</div></React.Fragment>;
      case 'form.form-group-element':
        return (
          <React.Fragment key={index}>
            <label className="form-label form-label-bold">{element.groupLabel}  {<span className={'error-message-astrid-show'}>*</span>}</label>

            {mapFormGroup(element.FormElements)}
          </React.Fragment>
        );
    }
  };

  const changeHandler = (FormName: string, FormValue: any, FormType: string, fileName?: any) => {
    if (FormType === 'file') {
      if (fileName.length === 1) {
        const filesData = fileName[0];
        formData.delete(`files.${FormName}`);
        formData.append(`files.${FormName}`, filesData, filesData.name);
        setFileData({ ...fileData, [`files.${FormName}`]: filesData });
        setfile({ ...file, [FormName]: filesData });
      } else {
        formData.delete(`files.${FormName}`);
        setfile({ ...file, [FormName]: null });
      }
    } else {
      setstate({ ...state, [FormName]: FormValue });
    }
  };

  const CustomToggle = ({ eventKey }: any) => {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;
    if (isCurrentEventKey) {
      return icons.up(color.$white, '');
    } else {
      return icons.plus(color.$white, '');
    }

  };
  return (
    <div className="ContactFormAccordion-container">
     
      <Accordion >
        <Card>
         <Accordion.Toggle
            as={Card.Header}
            eventKey="0"
            className="ContactFormAccordion-single-bg ContactFormAccordion-header"
            style={{ backgroundColor: '#F78B3D' }}
            tabIndex={0}
            aria-expanded={true}
          >
            <span >{props.data.title}</span>
            <CustomToggle eventKey="0"  />
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <div className="HeroFormAccordion-body" tabIndex={0}>
              {props.data.subTitle}
              <Form
                validated={validated}
                noValidate
                onChange={(event: any) => {
                  changeHandler(event.target.name, event.target.value, event.target.type, event.target.files);
                }}
                onSubmit={handleSubmit}

              >
                {props.data.Form.Elements?.map((items: any, index: number) => renderForm(items, index))}
              </Form>
            </div>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      { isSuccess && <div>
        <div className="herosuccessBackground">
          <div className="container">

            <div className="herosuccessmessage" dangerouslySetInnerHTML={{ __html: props.response.SuccessMessage[0].description  }} />
          </div>
          </div>
         </div>}
    </div>
  );
};

export default HeroesFormAccordion
